module.exports = __webpack_public_path__ + "static/media/low.59d5295d.svg";